import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconUpload = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "2px", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="currentColor"
        stroke={currentStroke}
        viewBox="0 0 24 24"
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.7068 5.29277L16.0401 8.62611L14.6259 10.0403L12.9995 8.41393L12.9995 14H10.9995L10.9995 8.41425L9.37345 10.0403L7.95923 8.6261L11.2926 5.29277C11.6831 4.90225 12.3163 4.90225 12.7068 5.29277ZM7 14V16.6667C7 16.8508 7.14924 17 7.33333 17H16.6667C16.8508 17 17 16.8508 17 16.6667V14H19V16.6667C19 17.9554 17.9553 19 16.6667 19H7.33333C6.04467 19 5 17.9554 5 16.6667V14H7Z"
        />
      </svg>
    );
  }
);
